<template>
    <div id="layouts-container" class="block-type-container">
		<span class="type-title">
			Custom Layouts
			<i @click="addLayout" class="material-icons" id="add-custom-block"
               data-tippy-content="Save New Custom Layout">add_circle_outline</i>
		</span>
        <div class="scrollable-con">
			<span
                v-for="layout in layouts"
                :key="layout.id"
                @click="applyLayout(layout.id)"
                class="control-name"
                data-name="custom-block"
                :category="layout.name"
            >
				<span class="control-label">{{ stripTimestampAndExtension(layout.name) }}</span>
				<i @click.stop="renameLayout(layout.id)" class="material-icons edit-custom-block-btn"
                   data-tippy-content="Rename Custom Layout"
                >edit</i
                >
				<i @click.stop="deleteLayout(layout.id)" class="material-icons delete-custom-block-btn"
                   data-tippy-content="Delete Custom Layout"
                >highlight_off</i
                >
			</span>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import FilenameMixin from "@/mixins/Filename";

export default {
    mixins: [FilenameMixin],
    computed: {
        ...mapState("UserFiles", ["layouts"]),
    },
    methods: {
        addLayout() {
            // TODO hide menu
            window.UI.showModal(window.UI.modals.customBlock.save.el);
        },
        applyLayout(id) {
            window.lutify.applyLayout(id);

            this.$store.dispatch('UI/setLeftColumn', 'appliedBlocks')
            window.UI.scrollToBlock(window.lutify.activeBlock);
        },
        deleteLayout(id) {
            this.$store.dispatch("UserFiles/selectLayout", id);
            window.UI.showModal(window.UI.modals.customBlock.delete.el);
        },
        renameLayout(id) {
            // TODO hide menu
            this.$store.dispatch("UserFiles/selectLayout", id);
            window.UI.showModal(window.UI.modals.customBlock.rename.el);
        },
    },
};
</script>

<style lang="scss" scoped></style>
